module.exports = __webpack_public_path__ + "img/GB@3x.96c944f3.png";